export default __webpack_public_path__ + "static/media/undraw_Charts_re_5qe9.f839bd09.svg";